/* eslint-disable camelcase */
import React from 'react'
import { Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'
import styles from './style.module.scss'
import bg from '../../assets/images/banner.png'

const AuthLayout = ({ children }) => {
  const isLoggedIn = useSelector(state => state?.user?.accessToken)

  if (isLoggedIn) {
    return <Redirect to="/" />
  }
  return (
    <>
      <img src={bg} className={styles.bgImage} alt="" />
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.formcon}>{children}</div>
          <div className="text-center mt-3 mb-3 font-size-14">
            <img className={styles.logo} src="resources/images/logo.svg" alt="" />
            <div className={styles.links}>
              <a
                href={process.env.REACT_APP_WEB_TERMS_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms
              </a>
              <div className={styles.dot} />
              <a
                href={process.env.REACT_APP_WEB_PRIVACY_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </div>
            <div className="font-size-12">Copyright © 2021 RewardUp Inc. All rights reserved.</div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AuthLayout
